module.exports = __webpack_public_path__ + "static/media/gravanis.e13168cb.md";